import { pathOr } from 'ramda';

import { IState } from '../../index';
import { IOfferHistoryData, TRoomsFiltersID, TStatusFilters, TStatusFiltersID } from '../types';

export const selectOfferHistoryData = (state: IState): IOfferHistoryData | null => state.offerHistory.data;

export const selectStatusFilters = (state: IState): TStatusFilters | null =>
  pathOr(null, ['offerHistory', 'data', 'statusFilters'], state);

export const selectRoomsFilters = (state: IState): TStatusFilters | null =>
  pathOr(null, ['offerHistory', 'data', 'roomsFilters'], state);

export const selectIsLoading = (state: IState): boolean => state.offerHistory.isFetching;

export const selectIsError = (state: IState): boolean => state.offerHistory.isError;

export const selectPageNumber = (state: IState): number => state.offerHistory.page;

export const selectResultsOnPage = (state: IState): number => state.offerHistory.resultsOnPage;

export const selectActiveRoomsFilter = (state: IState): [TRoomsFiltersID] | null | undefined =>
  state.offerHistory.roomsFiltersActiveIDs;

export const selectActiveStatusFilter = (state: IState): [TStatusFiltersID] | null | undefined =>
  state.offerHistory.statusFiltersActiveIDs;
